/* eslint-disable unicorn/catch-error-name */
/* eslint-disable unicorn/prefer-optional-catch-binding */
/* eslint-disable no-var */
/* eslint-disable wrap-iife */
import Component from '@glimmer/component';

import { ExternalScriptError, loadScript } from '@repo/shared-kit/utils';
import { didCancel, dropTask } from 'ember-concurrency';
import window from 'ember-window-mock';

import ENV from 'register-partners-js/config/environment';

// Component based on React implementation from official Didomi repo
// https://github.com/didomi/react
export default class DidomiSDKComponent extends Component {
  isTestEnvironment = ENV.environment === 'test';
  didomi = ENV.didomi ?? {};

  constructor() {
    super(...arguments);
    this.setEvents();
    this.initSDKTask.perform().catch(error => {
      if (!(didCancel(error) || error instanceof ExternalScriptError)) throw error;
    });
  }

  willDestroy() {
    super.willDestroy(...arguments);
    this.teardownEvents();
  }

  setEvents() {
    if (this.args.onReady) {
      window.didomiOnReady = window.didomiOnReady || [];
      window.didomiOnReady.push(this.args.onReady);
    }

    window.didomiEventListeners = window.didomiEventListeners || [];

    if (this.args.onConsentChanged) {
      window.didomiEventListeners.push({
        event: 'consent.changed',
        listener: e => this.args.onConsentChanged(e),
      });
    }
  }

  teardownEvents() {
    delete window.didomiOnReady;
    delete window.didomiEventListeners;
  }

  /**
   * Initialize the SDK, set the config object and insert the loader.js into the DOM
   */
  initSDKTask = dropTask(async () => {
    window.didomiConfig = this.config;
    window.didomiConfig.sdkPath = this.sdkPath;
    window.gdprAppliesGlobally = true;

    // Embed the TCF stub
    if (this.embedTCFStub) {
      // TCF v2
      // prettier-ignore
      (function(){function a(e){if(!window.frames[e]){if(document.body&&document.body.firstChild){var t=document.body;var n=document.createElement("iframe");n.style.display="none";n.name=e;n.title=e;t.insertBefore(n,t.firstChild)}else{setTimeout(function(){a(e)},5)}}}function e(n,r,o,c,s){function e(e,t,n,a){if(typeof n!=="function"){return}if(!window[r]){window[r]=[]}var i=false;if(s){i=s(e,t,n)}if(!i){window[r].push({command:e,parameter:t,callback:n,version:a})}}e.stub=true;function t(a){if(!window[n]||window[n].stub!==true){return}if(!a.data){return}var i=typeof a.data==="string";var e;try{e=i?JSON.parse(a.data):a.data}catch(t){return}if(e[o]){var r=e[o];window[n](r.command,r.parameter,function(e,t){var n={};n[c]={returnValue:e,success:t,callId:r.callId};a.source.postMessage(i?JSON.stringify(n):n,"*")},r.version)}}if(typeof window[n]!=="function"){window[n]=e;if(window.addEventListener){window.addEventListener("message",t,false)}else{window.attachEvent("onmessage",t)}}}e("__tcfapi","__tcfapiBuffer","__tcfapiCall","__tcfapiReturn");a("__tcfapiLocator");})();
    }

    let spcloaderId = 'spcloader';
    let spcloaderScript = document.getElementById(spcloaderId);
    if (spcloaderScript) {
      return;
    }

    let loaderParams = `target_type=notice&target=${this.noticeId}`;
    let scriptSrc = this.sdkPath + this.apiKey + '/loader.js?' + loaderParams;

    await loadScript(scriptSrc, spcloaderId);
  });

  get noticeId() {
    return this.isTestEnvironment ? this.didomi.noticeId : this.args.noticeId;
  }

  get sdkPath() {
    return this.isTestEnvironment ? this.didomi.sdkPath : this.args.sdkPath;
  }

  get apiKey() {
    return this.isTestEnvironment ? this.didomi.apiKey : this.args.apiKey;
  }

  get embedTCFStub() {
    return this.args.embedTCFStub ?? true;
  }

  get config() {
    let testConfig = {
      notice: { enable: false },
    };
    let config = this.args.config ?? {};
    return this.isTestEnvironment ? testConfig : config;
  }
}
